import { SERVER_URL } from '@/shared/lib/const/env'

export const API_STORAGE_KEY = 'debug_api_env'
export const API_COOKIE_KEY = 'debug_api_env'

export type ApiEnv = 'prod' | 'stage'

export interface DebugEnvConfig {
	SERVER_URL_PROD: string
	SERVER_URL_STAGE: string
}

const DEBUG_ENV_CONFIG: DebugEnvConfig = {
	SERVER_URL_PROD: 'https://api.samsungstore.ru',
	SERVER_URL_STAGE: 'https://stage.api.samsungstore.ru'
}

export const API_URLS: Record<ApiEnv, string> = {
	prod: DEBUG_ENV_CONFIG.SERVER_URL_PROD,
	stage: DEBUG_ENV_CONFIG.SERVER_URL_STAGE
}

const getCookie = (name: string): string | null => {
	if (typeof document === 'undefined') return null
	const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
	return match ? match[2] : null
}

export const setCookie = (name: string, value: string): void => {
	if (typeof document === 'undefined') return
	document.cookie = `${name}=${value};path=/;max-age=31536000`
}

export const getSelectedApiEnv = (): ApiEnv | null => {
	if (process.env.NODE_ENV !== 'development') return null

	if (typeof window !== 'undefined') {
		const fromCookie = getCookie(API_COOKIE_KEY)
		if (fromCookie === 'prod' || fromCookie === 'stage') return fromCookie

		const fromStorage = localStorage.getItem(API_STORAGE_KEY) as ApiEnv | null
		return fromStorage
	}

	return null
}

export const getServerUrl = (): string => {
	if (process.env.NODE_ENV !== 'development') return SERVER_URL
	if (typeof window === 'undefined') return SERVER_URL

	const selectedEnv = getSelectedApiEnv()

	if (selectedEnv && API_URLS[selectedEnv]) {
		return API_URLS[selectedEnv]
	}

	return SERVER_URL
}

export const getApiUrl = (): string => {
	return `${getServerUrl()}/api`
}

export const getServerUrlFromCookieString = (cookieString: string): string => {
	if (process.env.NODE_ENV !== 'development') return SERVER_URL

	const match = cookieString.match(new RegExp('(^|; )' + API_COOKIE_KEY + '=([^;]+)'))
	const envValue = match ? match[2] : null

	if (envValue === 'prod') return DEBUG_ENV_CONFIG.SERVER_URL_PROD
	if (envValue === 'stage') return DEBUG_ENV_CONFIG.SERVER_URL_STAGE

	return SERVER_URL
}
